import { render, staticRenderFns } from "./TaskA.vue?vue&type=template&id=d4167e42&scoped=true"
import script from "./TaskA.vue?vue&type=script&lang=ts"
export * from "./TaskA.vue?vue&type=script&lang=ts"
import style0 from "./TaskA.vue?vue&type=style&index=0&id=d4167e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4167e42",
  null
  
)

export default component.exports